export const debounceTime = 500;

export function noResults(keyword: string | null | undefined) {
  return { keyword: keyword ?? '', count: 0, products: [] };
}
